import styled, { css } from 'styled-components'
import Flex from '@/components/priority/Flex/Flex'
import colors from '@/utils/styling/colors'

export const DARK_PREVIEW_BG = '#1a1a1a'
export const LIGHT_PREVIEW_BG = 'white'

export const TemplateItem = styled(Flex)<{ $disabled?: boolean }>`
  border: 1px solid ${colors('gray4')};
  border-radius: 8px;
  padding: 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  transition: all 0.2s;
  background: ${colors('gray2')};
  margin-bottom: 16px;

  ${({ $disabled }) =>
    $disabled
      ? ''
      : css`
          &:hover {
            border-color: ${colors('brand')};
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          }
        `}
`

export const TemplatePreview = styled(Flex)<{ $darkBg?: boolean }>`
  padding: 12px;
  background: ${({ $darkBg }) =>
    $darkBg ? DARK_PREVIEW_BG : LIGHT_PREVIEW_BG};
  border-radius: 4px;
  border: 1px solid ${colors('gray4')};
  min-height: 60px;
  overflow: auto;
  pointer-events: none;
  width: 100%;
  transition: background 0.2s ease;
`

export const CategoryHeader = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors('gray2')};
  padding: 16px 0 8px 0;
  border-bottom: 1px solid ${colors('gray4')};
  margin-bottom: 8px;
`

export const BackgroundToggle = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid ${colors('gray4')};
  background: ${({ $active }) =>
    $active ? DARK_PREVIEW_BG : LIGHT_PREVIEW_BG};
  color: ${({ $active }) => ($active ? LIGHT_PREVIEW_BG : DARK_PREVIEW_BG)};
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    border-color: ${colors('brand')};
  }

  svg {
    width: 14px;
    height: 14px;
  }
`
